<template>
    <div>
        <div class="container" >
            <div v-for="(item,index) in newsTitle" :key="index" class="single_news" >
                <div class="news_img">
                    <img :src=item.imgPath[0]  alt="">
                </div>              
                <div class="card">
                    <div class="quote">
                        <router-link tag="a" :to="{
                            name:'NewsContent',
                            query: {   
                                id: item.id, // orderNum : this.searchData.orderNo
                                page:formData
                            }
                        }">
                        <h3 style="line-height: 38px;">{{item.infoTitle}}</h3>
                        </router-link>
                     </div>
                <router-link class="details" tag="a" :to="{
                            name:'NewsContent',
                            query: {   
                                id: item.id, // orderNum : this.searchData.orderNo
                                page:formData
                            }
                        }">
                    内容：{{item.contentDetail}}
                </router-link>
                <div class="details2">
                    <p class="details2-p1" style="display: inline;">{{item.type}}</p>
                    <p class="details2-p2" style="display: inline-block;">{{item.infoDate}}</p>
                </div>
            </div> 
        </div>       
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.page    "
        :page-sizes="[20,60,100,140]"
        :page-size='20'
        layout="total, sizes, prev, pager, next, jumper"
        :total="count">
    </el-pagination>
</div>
</div>
</template>

<script>
    export default {
        name: 'News',
        components: {

        },
        data(){
         return {
          formData:{
              page:1,
              limit:10,
          },
          newsTitle:[],
          count:0

      }
  },
  methods:{
    getNewsTitle(){
        this.$http.post('/v2/SearchNewsTitle',{formdata:this.formData}).then(res =>{console.log(res.data)
            this.newsTitle = res.data;
            this.count = res.count;
            var nowData=this.newsTitle;
            for(var i=0;i<nowData.length;i++){
                // console.log(nowData[i].jsonContent);
                // console.log(JSON.parse(nowData[i].jsonContent));
                var nowItemJSON=JSON.parse(nowData[i].jsonContent);
                    // 单个新闻渲染的内容
                    var newContentShowSingle="";
                    for(var n=0;n<nowItemJSON.length;n++){
                        if(nowItemJSON[n].str){
                            if(nowItemJSON[n].str!=""){
                                newContentShowSingle+=nowItemJSON[n].str[0];
                            }
                        }
                    }
                    // console.log(newContentShowSingle)
                    this.newsTitle[i].contentDetail=newContentShowSingle;
                    var end = this.newsTitle[i].imgPath.length - 2
                    this.newsTitle[i].imgPath = this.newsTitle[i].imgPath.slice(2,end)
                        this.newsTitle[i].imgPath = this.newsTitle[i].imgPath.split("\", \"")
                        for (var j = 0 ; j < this.newsTitle[i].imgPath.length ;j ++){
                            this.newsTitle[i].imgPath[j] = "https://hy.imould.com" + this.newsTitle[i].imgPath[j]
                        }
                }
                this.$scrollTo();
            }).catch(error =>{

            })
        },
        handleSizeChange(val) {
            this.formData.limit = val;
            this.getNewsTitle()
        },
        handleCurrentChange(val) {
            this.formData.page = val;
            this.getNewsTitle()
        }
    },
    created(){
       this.getNewsTitle()
   },
   mounted(){

   }
}
</script>

<style scoped>
.single_news{
    margin-bottom: 20px;
    border-bottom: 1px solid #efefef;
    padding: 20px;
    width: 100%;
    overflow: hidden;

}
.single_news a{
    color: #333;
   
}
.single_news a:hover{text-decoration: underline;}
.news_img{ float: left; margin-right: 50px;}
.news_img img{
    width: 270px;
    height: 195px;
}
.container:first-child{
    margin-top: 25px;
}
.quote{
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 1.2;
}
.quote:hover a{
    color: #0051A4;
}

.details{
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:3;
    -webkit-box-orient:vertical;
    overflow:hidden;
    font-size: 15px;
    line-height: 1.8;
    color: black;

}
.details2{
    line-height: 22px;
    font-size: 14px;
    padding-top: 25px;
      color: black;
}

.card{
    position: relative;
    
}
.details2-p2{
    padding-left: 50px;
}
* >>> .el-pagination{text-align: center;padding: 15px 0;}
</style>